import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'material-ui/Tabs';
import classes from './SideBar.scss';
import SideBarTasks from '../SideBarTasks/SideBarTasks';
import SideBarActivities from '../SideBarActivities/SideBarActivities';
import { fetchActivity } from '../../store/modules/activity';
import { fetchTask } from '../../store/modules/task';

const mapActionCreators = {
  fetchTask,
  fetchActivity,
};

const mapStateToProps = state => ({
  open: state.options.sidebarOpen,
  login: state.login,
});

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    props.fetchTask();
    props.fetchActivity();
  }

  render() {
    if (
      this.props.open === false ||
      typeof this.props.login === 'undefined' ||
      this.props.login.isAuthenticated === false
    ) {
      return <div className={classes.closed} />;
    }

    return (
      <div className={classes.taskbar}>
        <Tabs
          className={classes.tabs}
          contentContainerClassName={classes.tabscontainer}
          inkBarStyle={{ backgroundColor: '#4a90e2' }}
          tabItemContainerStyle={{
            backgroundColor: '#ffffff',
            height: 60,
            minHeight: 60,
          }}
        >
          <Tab
            label="Aktivitäten"
            className={classes.tab}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <SideBarActivities />
          </Tab>
          <Tab
            label="Aufgaben"
            className={classes.tab}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <SideBarTasks />
          </Tab>
        </Tabs>
      </div>
    );
  }
}
SideBar.propTypes = {
  open: PropTypes.bool,
  login: PropTypes.object,
  fetchTask: PropTypes.func.isRequired,
  fetchActivity: PropTypes.func.isRequired,
};
SideBar.defaultProps = {
  open: false,
  login: {},
};
export default connect(mapStateToProps, mapActionCreators)(SideBar);



// WEBPACK FOOTER //
// ./src/components/SideBar/SideBar.js